<template>
    <div class="document-list" :class="statusClass">
        <!-- Header -->
        <div class="document-list__header clearfix">
            <table width="100%">
                <thead style="background:none">
                    <tr>
                        <td :class="{'document-list__uploadExisting' :showUpload}">
                            <div class="document-list__heading">
                                <span class="document-list__title">{{documentDisplayName}}</span>
                                <template v-if="status === 'default' || status === 'initiate' || status === 'reviewpending'">
                                    <span class="document-list__status">?</span>
                                </template>
                                <template v-else-if="status === 'failure'">
                                    <span class="document-list__status" style="font-size: 14px;padding: 0px 6px;color: #d92e42;background: #f9a3ae;">&times;</span>
                                </template>
                                <template v-else-if="status === 'Pending'">
                                    <span class="document-list__status" style="color:#F5A623;background: #ffd590;">?</span>
                                </template>
                                <template v-else>
                                    <span class="document-list__status" style="font-size: 10px; padding: 2px 5px; color: #1DC942;">&#10003;</span>
                                </template>
                            </div>
                        </td>
                        <td style="padding-left:62px;" :class="{'document-list__uploadExisting' :showUpload,'document-list__existingI9':showUpload}">
                            <span v-if="status != 'archived'" class="document-list__statusHeading">Status</span>
                        </td>
                        <td align="right" style="text-align:right" :class="{'document-list__uploadExisting' :showUpload}">
                            <!-- <ob-button :type="status === 'initiate' ? 'secondary' : 'primary'" :disabled="status === 'initiate' || this.consultantDetails.IsEmployeeTerminated" v-if="isProceed" @click="buttonActions('proceed')">Proceed to Section - 2</ob-button>
                            <ob-button type="primary" :disabled="this.consultantDetails.IsEmployeeTerminated" v-if="status === 'pending' && documentList.AuthorizationType =='EmployerLocation' && documentList.UploadingExistingI9 != true" @click="buttonActions('validateProceed')">Validate and Proceed</ob-button>
                            <ob-button type="primary" :disabled="this.consultantDetails.IsEmployeeTerminated" v-if="status === 'pending' && documentList.AuthorizationType =='RemoteLocation' && documentList.UploadingExistingI9 != true" @click="buttonActions('validate')">Validate</ob-button>
                            <ob-button type="secondary" :disabled="this.consultantDetails.IsEmployeeTerminated" v-if="status === 'initiate' && documentList.AuthorizationType =='RemoteLocation'" @click="resendLink">Resend link</ob-button> -->

                            <ob-dropdown title="Actions" v-if="status != 'initiate'">
                                <!-- <ob-dropdown-list-item @click.native="changeDocument(documentList)" v-if="changeSupportingShow && !consultantDetails.IsEmployeeTerminated">Change supporting document</ob-dropdown-list-item> -->
                                <!-- <ob-dropdown-list-item v-if="updateSection && !consultantDetails.IsEmployeeTerminated" @click.native="updateSection1(documentList)">Update</ob-dropdown-list-item> -->
                                <ob-dropdown-list-item @click.native="viewDocument(documentList,'section1')">Preview</ob-dropdown-list-item>
                                <!-- <ob-dropdown-list-item v-if="status != 'archived'" @click.native="printDocument(documentList,'section1')">Print</ob-dropdown-list-item> -->
                                <ob-dropdown-list-item @click.native="downloadDocument(documentList,'section1')">Download</ob-dropdown-list-item>
                                <ob-dropdown-list-item v-if="documentList.SignedDocumentUrl != null && documentList.SignedDocumentUrl != '' && documentDisplayName == 'Section - 1'" @click.native="viewSignDocument(documentList,'signdoc')">Signature Certificate</ob-dropdown-list-item>
                                <!-- <ob-dropdown-list-item @click.native="$emit('modifyVerificationLocation')">Modify Verification Location</ob-dropdown-list-item> -->
                                <!-- <ob-dropdown-list-item @click.native="updateSSN(documentList)" v-if="showSSN && !consultantDetails.IsEmployeeTerminated">Update SSN</ob-dropdown-list-item> -->
                            </ob-dropdown>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <span>
                                <span style="color:#333;padding-top:5px;display:block;font-weight: 600;font-size:9px;" >
                                    Employment Start Date: {{EmploymentStartDateString}}
                                </span>
                                <span style="color:#333;padding-top:5px;display:inline;font-weight: 600;font-size:9px;" v-if="status == 'initiate'">
                                    Initiated Date: <span>{{documentsTableHeader.InitiatedDate}}</span>
                                </span>

                                <span style="color:#333;padding-top:5px;display:inline;font-weight: 600;font-size:9px;" v-else>
                                    Created/Signed Date: <span>{{documentsTableHeader.SignedDate}}</span>
                                </span>

                                <span style="color:#333;padding-top:5px;display:inline;font-weight: 600;font-size:9px;" v-if="documentsTableHeader.ModifiedDate !== 'N/A'">
                                    Last Modified Date: <span>{{documentsTableHeader.ModifiedDate}}</span>
                                </span>
                            </span>
                        </td>
                        <td style="padding-left:0px;" :class="{'document-list__uploadExisting' :showUpload}">
                            <span v-if="status != 'archived'" class="document-list__statusResult">{{statusText}}</span>
                        </td>
                        <td>
                            <a v-if="((status == 'initiate' || status == 'reviewpending') && documentList.AuthorizationType !='RemoteLocation') || (status == 'reviewpending' && documentList.AuthorizationType == 'RemoteLocation')" class="document-list__resendLink" @click="resendLink">Resend Section-1 form link</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Body -->
        <div class="document-list__body" v-if="documentsTableData && documentsTableData.length > 0">
            <div class="document-list__uploadedSection">
                <div class="document-list__uploadedDocs" v-for="(d, dIndex) in documentsTableData" :key="dIndex">
                    <span class="document-list__title text_Namefol" :title="d.DocumentUrl | I9URL2FileName">{{d.DocumentUrl | I9URL2FileName}}</span>
                    <!--<img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/docs_down_arrow.jpg`"/>-->
                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                        <div class="popper" style="padding:0px">
                            <div class="document-popover" style="background:#f1f1f1" v-if="d.ExpiryDate != '0001/01/01T00:00:00'">
                                <!--<div style="padding:10px;display:inline-block;">
                                <p>Issue Date</p>
                                <p>{{d.IssueDate}}</p>
                            </div>-->
                                <div style="padding:10px;display:inline-block">
                                    <p>Expiry Date</p>
                                    <p>{{d.ExpiryDate}}</p>
                                </div>
                            </div>
                            <div style="padding:10px;">
                                <!-- <span style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(d.DocumentUrl)" /></span> -->
                                <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(d.DocumentUrl)" /></span>
                                <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(d.DocumentUrl)" /></span>
                            </div>
                        </div>

                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-top:-7px;" />

                    </ob-popover>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
   // import I9CommonFunctionMixin from '../I9DocumentListMixin.js'
    import c from '@/components/Core/constants.js'
    import utils from '@/components/Core/utils.js'

    export default {
        name: 'ob-I9-doclist',
        //mixins: [I9CommonFunctionMixin],
        props: {
            documentList: {
                type: Object,
                required: true
            },
            documentDisplayName: {
                type: String,
                required: true
            },
            completeI9Details: {
                type: Object
            },

        },

        data() {
            return {
                doValidation: false,
                isFormValid: false,
                isUploading: false,
                show: false,
                oldFieldValues: {},
                fieldValues: {},
                modalType: "",
                openSec2EmpDateContentPopup: false,
                daysPassed: '',
                i9ReasonText: '',
                dateTimeKeys: [
                    "IssueDate",
                    "ExpiryDate",
                    "PODate",
                    "I94StartDate",
                    "I94EndDate",
                    "SignedDate",
                    "CertifiedDate",
                ],
                i9DocListAlerts: []
            }
        },
        components: {


        },
        computed: {
            status() {
                if(this.documentsTableHeader.Status != '' && this.documentsTableHeader.Status != null){
                    return this.documentsTableHeader.Status.toLowerCase()
                }else{
                    return ''
                }

            },
            cSection1Dates(){
                let section1Dates = {}
                this.completeI9Details.I9DatesMetaDataValues.Section1Dates.forEach((section1) => {
                    if(section1.Section1Id === this.documentList.Id){
                        section1Dates.Section1Id = section1.Section1Id
                        section1Dates.CreatedDate = section1.CreatedDate
                        section1Dates.ModifiedDate = section1.ModifiedDate
                        section1Dates.SignedDate = section1.SignedDate
                        section1Dates.SupportingDocuments = section1.SupportingDocuments
                        section1Dates.DocumentList = section1.DocumentList
                    }
                })
                return section1Dates
            },
            EmploymentStartDateString(){
                return this.completeI9Details.I9DatesMetaDataValues.EmploymentStartDate;
            },
            documentsTableHeader() {
                let docHeader = {}
                let section1Dates = this.cSection1Dates;
                docHeader.InitiatedDate = section1Dates.CreatedDate
                docHeader.SignedDate = section1Dates.SignedDate
                docHeader.ModifiedDate = section1Dates.ModifiedDate
                if (this.documentList.Status != undefined)
                    docHeader.Status = this.documentList.Status
                else
                    docHeader.Status = this.documentList.DocumentStatus

                return docHeader
            },

            documentsTableData() {

                let documentsTableData = [];
                let section1Dates = this.cSection1Dates;
                if(section1Dates != null && this.completeI9Details.IsSupportingDocumentsRequired){
                    let SupportingDocuments = section1Dates.SupportingDocuments != null && section1Dates.SupportingDocuments != undefined ? section1Dates.SupportingDocuments : ''
                    if(SupportingDocuments != ''){
                        SupportingDocuments.forEach((td) => {
                            if (td.DocumentUrl != '') {
                                let doc = {}
                                doc.IssueDate = td.IssueDate
                                doc.ExpiryDate = td.ExpiryDate
                                doc.DocumentUrl = td.DocumentUrl
                                doc.DocumentId = td.Id

                                documentsTableData.push(doc)
                            }
                        })
                    }
                }
                /*if ((this.documentList.DocumentList != null) && (this.completeI9Details.H1BDetails != null && this.completeI9Details.H1BDetails.H1BType == "H1BTransfer")) {
                    this.documentList.DocumentList.forEach((td) => {
                        let doc = {}
                        if (td.DocType == 'CourierReciept' || td.DocType == 'FormI129FeeReceipt' || td.DocType == 'FormI129ReceiptNotice') {
                            doc.IssueDate = td.IssueDate
                            doc.ExpiryDate = td.ExpiryDate
                            doc.DocumentUrl = td.DocumentUrl
                            doc.DocumentId = td.Id

                            documentsTableData.push(doc)
                        }
                    })
                }*/
                console.log("documentsTableData",documentsTableData)
                return documentsTableData
            },
            statusClass() {
                if (this.status === 'default' || this.status == 'reviewpending') {
                    return 'document-list--default'
                } else if (this.status === 'success' || this.status === 'validated' || this.status === 'pending' || this.status == 'archived') {
                    return 'document-list--success'
                } else if (this.status === 'failure') {
                    return 'document-list--failure'
                } else if (this.status === 'warning') {
                    return 'document-list--warning'
                }
            },
            statusText() {

                if (this.documentList.UploadingExistingI9 != true) {
                    if (this.status == 'initiate') {

                        return 'Waiting for Section 1'
                    }
                    else if (this.status == 'pending') {

                        return 'Received'
                    }
                    else if (this.status == 'validated') {

                        return 'Validated'
                    }
                    else if (this.status == 'reviewpending')

                        return 'Waiting for Section 1'
                }
                else {
                    if (this.status == 'pending' || this.status == 'validated')
                        return 'Saved'
                }
            },
            isProceed() {
                if (this.documentList.AuthorizationType != 'RemoteLocation' && this.documentList.UploadingExistingI9 != true) {
                    if (this.status === 'validated' || this.status === 'initiate') {
                        if (this.completeI9Details.I9Section2Details.length >= 1) {
                            if (this.completeI9Details.I9Section2Details[0].Status == 'Initiate')
                                return true
                            else
                                return false
                        }
                    }
                    else
                        return false
                }
                else
                    return false
            },
            consultantDetails() {
                return this.$store.getters.getConsultantDetails
            },
            changeSupportingShow() {
                if (this.documentList.UploadingExistingI9 != true) {
                    if (this.documentList.Agent != null) {
                        return false
                    }
                    else {
                        if (this.status == 'validated' && this.completeI9Details.I9Section2Details[0].Status != 'Validated') {
                            return true
                        } else {
                            return false
                        }
                    }
                }
                else return false
            },
            showSSN() {
                if (this.documentList.UploadingExistingI9 != true) {
                    if (this.status != 'archived') {
                        if (this.completeI9Details.EverifyDetails == null && (this.documentList.Employee.Contact.SocialSecurtiyNumber == null || this.documentList.Employee.Contact.SocialSecurtiyNumber == ''))
                            return true
                        else return false
                    }
                    else return false
                }
                else return false
            },
           /* updateSection() {
                //let section2Status = this.completeI9Details.I9Section2Details[0].Status;
                if (this.documentList.UploadingExistingI9 != true) {
                    if (this.status != 'archived' && this.status == 'validated' && (section2Status == 'Validated' || section2Status == 'ReviewPending')) {
                        return true
                    }
                    else return false
                }
                else return true
            },*/
            showUpload() {
                if (this.documentList.UploadingExistingI9 == true && this.completeI9Details.IsSupportingDocumentsRequired == true) // && this.completeI9Details.I9Section2Details[0].Status == 'Pending'
                    return true
                else return false
            },
            canShowOnboardingSummary() {
                if (this.$route.query.jobId && this.$route.query.jobId != "" && this.consultantDetails && this.consultantDetails.IsOnBoarding == true) {
                    return true;
                } else {
                    return false;
                }
            },
            /*anyDocumentListAlerts() {
                let section1Alerts = [];
                if (this.documentList != null && this.documentList.UploadingExistingI9 != true) {
                    //1
                    if (this.completeI9Details.I9Warnings == 4 && this.documentList.Status != null && this.documentList.Status == 'Initiate') {
                        section1Alerts.push('Section-1 of Form I-9 should be completed by end of the day ' + moment(String(this.i9Details.EmployementStartDate)).format('MM/DD/YYYY') + '. Please ensure that the candidate submits the signed Section-1.');
                    }
                    //2
                    if (this.documentList.Status != null && this.documentList.Status == "ReviewPending") {
                        var TodaysDate = this.completeI9Details.TodaysDate;
                        TodaysDate = moment(TodaysDate).format('MM/DD/YYYY HH:mm');
                        var I9Section1ModifiedDate = this.documentList.ModifiedDateTime;
                        I9Section1ModifiedDate = moment(I9Section1ModifiedDate).format('MM/DD/YYYY HH:mm');
                        //I9Section1ModifiedDate = moment(I9Section1ModifiedDate).add(1,'days').format('MM/DD/YYYY HH:mm');
                        var difference = moment(TodaysDate).diff(I9Section1ModifiedDate, 'hours');
                        if (difference >= 3) {
                            section1Alerts.push(`Candidate has not updated his section-1 with the requested changes yet.`);
                        }
                    }
                    //3
                    if (this.documentList.Employee != null && this.documentList.Employee.Contact != null && this.documentList.Employee.Contact.SocialSecurtiyNumber == '') {
                        section1Alerts.push(`Employee's SSN number is missing please update.`);
                    }
                    //4
                    if (this.documentList.Status != null && this.documentList.Status == 'Validated' && this.documentList.AuthorizationType == 'EmployerLocation') {
                        var ThirdEmploymentDate = moment(String(this.completeI9Details.ThirdEmploymentDate)).format('MM/DD/YYYY');
                        var TodaysDate = moment(String(this.completeI9Details.TodaysDate)).format('MM/DD/YYYY');
                        if (this.completeI9Details.I9Section2Details != null && this.completeI9Details.I9Section2Details[0] != null && this.completeI9Details.I9Section2Details[0].Status == 'Initiate') {
                            if (TodaysDate <= ThirdEmploymentDate) {
                                section1Alerts.push('Section-2 of Form I-9 should be completed by the end of ' + ThirdEmploymentDate);
                            }
                        }
                    }

                }
                this.i9DocListAlerts = section1Alerts;
                if (section1Alerts.length > 0)
                    return true;
                else
                    return false;
            }*/
        },
        methods: {
           /* section2alertpopup() {
                let orgId = this.documentList.CreatedBy.Organization.Id, child, specs = 'width=1400,height=660'
                this.actionLogSection2Initiate()
                let urlForDelay = `${c.APPLICATIONBASEURL}/I9/I9Section2Form?consultantId=${loggedInUserObj.consultantId}&employerOrgId=${orgId}&role=HRManager`
                let childForDelay = window.open(urlForDelay, '_blank', specs)
            },*/
            /*calculateDaysPassed() {
                if (this.i9Details != null && this.i9Details.TodaysDate != null && this.i9Details.EmployementStartDate != null) {
                    var todaysDate = moment(this.i9Details.TodaysDate).format('MM/DD/YYYY');
                    var employmentStartDate = moment(this.i9Details.EmployementStartDate).format('MM/DD/YYYY');
                    var difference = moment(todaysDate).diff(employmentStartDate, 'days');
                    return difference;
                }
            },*/
            viewSignDocument(doc, section) {
                if (section == 'signdoc')
                utils.previewSingleDoc(doc.SignedDocumentUrl)
                //window.open(doc.SignedDocumentUrl, '_blank')
            },

            viewDocument(doc, section) {
                    if (section == 'everify') {
                        let url
                        doc.DocumentList.forEach((d) => {
                            if (d.DocType == 'DHSEmploymentAuthorization')
                                url = d.DocumentUrl;
                        })
                        utils.previewSingleDoc(url)
                        //window.open(url, '_blank')
                        //window.open(utils.getFilePreviewLink(url), '_blank')
                    }
                    else {
                        let CompleteI9PdfUrl = doc.CompleteI9PdfUrl
                        let section1PdfUrl = doc.PdfUrl
                        let section2PdfUrl = doc.PdfUrl
                        let section3PdfUrl = doc.PdfUrl
                        if (doc.UploadingExistingI9 == true) {
                            if(section=='complete'){
                                this.$loading({ 'loadingText': 'Loading...' })
                                if(this.CompleteI9PdfUrl != '' && this.CompleteI9PdfUrl != null){
                                    this.$loading({}).close()
                                    utils.previewSingleDoc(CompleteI9PdfUrl)
                                   // window.open(CompleteI9PdfUrl, '_blank')
                                }else{
                                    URL = `/I9/GeneratePdfForCompleteI9?consultantId=${loggedInUserObj.consultantId}`
                                    ajax.post(URL, {}, (res) => {
                                        if (res.data != '') {
                                            this.$loading({}).close()
                                            //window.open(res.data, '_blank')
                                            utils.previewSingleDoc(res.data)
                                            //window.open(utils.getFilePreviewLink(res.data), '_blank')
                                        }
                                    })
                                }
                            } else {
                                //window.open(doc.DocumentUrl, '_blank')
                                utils.previewSingleDoc(doc.DocumentUrl)
                                //window.open(utils.getFilePreviewLink(doc.DocumentUrl), '_blank')
                            }

                        }
                        else {
                            this.$loading({ 'loadingText': 'Loading...' })
                            let URL
                            if (section == 'section1')
                                URL = `/I9/GeneratePdfForSection1?section1Id=${doc.Id}`
                            else if (section == 'section2')
                                URL = `/I9/GeneratePdfForSection2?section2Id=${doc.Id}`
                            else if (section == 'section3')
                                URL = `/I9/GeneratePdfForSection3?section3Id=${doc.Id}`
                            else if (section == 'complete')
                                URL = `/I9/GeneratePdfForCompleteI9?consultantId=${loggedInUserObj.consultantId}`
                            if(section == 'complete')
                            {
                                if(CompleteI9PdfUrl){
                                    this.$loading({}).close()
                                    utils.previewSingleDoc(CompleteI9PdfUrl)
                                }
                                else{
                                    ajax.post(URL, {}, (res) => {
                                        if (res.data != '') {
                                            this.$loading({}).close()
                                            utils.previewSingleDoc(res.data)
                                            //window.open(res.data, '_blank')
                                        }
                                    })
                                }
                            }
                            else if(section=='section1')
                            {
                                if(section1PdfUrl){
                                    this.$loading({}).close()
                                    utils.previewSingleDoc(section1PdfUrl)
                                }
                                else{
                                    ajax.post(URL, {}, (res) => {
                                        if (res.data && res.data.GeneratedURL) {
                                            this.$loading({}).close()
                                            utils.previewSingleDoc(res.data.GeneratedURL)
                                        }
                                    })
                                }
                            }
                            /*else if(section=='section2' && !this.IsNullOrEmpty(section2PdfUrl))
                            {
                                this.$loading({}).close()
                                window.open(section2PdfUrl, '_blank')
                            }else if(section=='section3' && !this.IsNullOrEmpty(section3PdfUrl))
                            {
                                this.$loading({}).close()
                                window.open(section3PdfUrl, '_blank')
                            }*/
                        }
                    }
            },

            createIframe(srcFile) {

                var objFra = document.createElement('iframe');
                objFra.style.visibility = "hidden";
                objFra.src = srcFile;
                document.body.appendChild(objFra);
                objFra.contentWindow.focus();
                objFra.contentWindow.print();
            },

            buttonActions(action) {
                let TodaysDate = moment(this.i9Details.TodaysDate).format('MM/DD/YYYY');
                let ThirdEmploymentStartDate = moment(this.i9Details.ThirdEmploymentDate).format('MM/DD/YYYY');
                let orgId = this.documentList.CreatedBy.Organization.Id, child, specs = 'width=1400,height=660'

                if (action == 'validateProceed') {
                    this.actionLogValidate()
                    let url = `${c.APIBASEURL}/i9/getverifyi9details?consultantId=${loggedInUserObj.consultantId}&orgId=${orgId}`
                    let child = window.open(url, '_blank', specs)
                }
                else if (action == 'validate') {
                    this.actionLogValidate()
                    let url = `${c.APIBASEURL}/i9/getverifyi9details?consultantId=${loggedInUserObj.consultantId}&orgId=${orgId}&type=validate`
                    let child = window.open(url, '_blank', specs)
                }
                else if (TodaysDate > ThirdEmploymentStartDate) {
                    this.openSec2EmpDateContentPopup = true;
                    this.daysPassed = this.calculateDaysPassed();
                }
                else {
                    this.actionLogSection2Initiate()
                    let url = `${c.APIBASEURL}/I9/I9Section2Form?consultantId=${loggedInUserObj.consultantId}&employerOrgId=${orgId}&role=HRManager`
                    let child = window.open(url, '_blank', specs)
                }
                events.fire('openedChild', child)
            },
            resendLink() {
                events.fire('resendSection1')
            },
            actionLogValidate() {
                let currentDate = moment.utc(new Date())
                let params = {
                    Message: 'Section 1 validation initiated by Employer',
                    I9ActionLogAction: 'Section1Validate',
                    CreatedDateTime: currentDate,
                    CreatedBy: {
                        'Id': this.documentList.CreatedBy.Id,
                        'FirstName': this.documentList.CreatedBy.FirstName,
                        'LastName': this.documentList.CreatedBy.LastName,
                        'CurrentRole': this.documentList.CreatedBy.CurrentRole,
                        'Organization': this.documentList.CreatedBy.Organization
                    }

                }
                ajax.put(`/I9/InsertI9ActionLog?consultantId=${this.$route.params.id}&orgId=${this.documentList.CreatedBy.Organization.Id}`, params, (res) => {


                })
            },
            actionLogSection2Initiate() {
                let currentDate = moment.utc(new Date())
                let Message
                if (this.i9ReasonText != '') {
                    Message = this.documentList.AuthorizationType == 'RemoteLocation' ? 'Signing of electronic version of section-2 has been initiated by the Authorized representative.' : `Signing of the electronic version of Section-2 has been initiated by the Employer after the employment start-day has passed by 3 days. Reason for delay: ` + this.i9ReasonText
                }
                else {
                    Message = this.documentList.AuthorizationType == 'RemoteLocation' ? 'Signing of electronic version of section-2 has been initiated by the Authorized representative.' : 'Signing of the electronic version of section-2 has been initiated by the Employer.'
                }
                let params = {
                    Message: Message,
                    I9ActionLogAction: 'Section2Initiated',
                    CreatedDateTime: currentDate,
                    CreatedBy: {
                        'Id': this.documentList.CreatedBy.Id,
                        'FirstName': this.documentList.CreatedBy.FirstName,
                        'LastName': this.documentList.CreatedBy.LastName,
                        'CurrentRole': this.documentList.CreatedBy.CurrentRole,
                        'Organization': this.documentList.CreatedBy.Organization
                    }

                }
                ajax.put(`/I9/InsertI9ActionLog?consultantId=${this.$route.params.id}&orgId=${this.documentList.CreatedBy.Organization.Id}`, params, (res) => {


                })
            },


            // functions from mixins - new

            printSingleDoc(doc) {

                let url = doc.replace(/^http:\/\//i, 'https://');
                this.createIframe(url)
            },

            downloadSingleDoc(doc) {
                // let d = doc + "&download=true";
                // window.open(d, '_blank')
                utils.downloadSingleDoc(doc)
            },
            previewSingleDoc(doc) {
                //window.open(doc,'_blank')
                utils.previewSingleDoc(doc)
                //window.open(utils.getFilePreviewLink(doc),'_blank')
            },


            downloadDocument(doc, section) {

                if (section == 'everify') {
                    let url
                    doc.DocumentList.forEach((d) => {
                        if (d.DocType == 'DHSEmploymentAuthorization')
                            url = d.DocumentUrl;
                    })
                    //window.open(url, '_blank');
                    utils.downloadSingleDoc(url)
                }
                else {
                    let CompleteI9PdfUrl = doc.CompleteI9PdfUrl
                    let section1PdfUrl = doc.PdfUrl
                    let section2PdfUrl = doc.PdfUrl
                    let section3PdfUrl = doc.PdfUrl
                    if (doc.UploadingExistingI9 == true) {
                        if(section == 'complete'){
                            if(this.CompleteI9PdfUrl != '' && this.CompleteI9PdfUrl != null){
                                this.$loading({}).close()
                                let d = CompleteI9PdfUrl;
                            // window.open(d, '_blank');
                            utils.downloadSingleDoc(d)
                            }else{
                                this.$loading({ 'loadingText': 'Downloading...' })
                                URL = `/I9/GeneratePdfForCompleteI9?consultantId=${loggedInUserObj.consultantId}`
                                ajax.post(URL, {}, (res) => {
                                    if (res.data != '') {
                                        this.$loading({}).close()
                                        let d = res.data;
                                        //window.open(d, '_blank');
                                        utils.downloadSingleDoc(d)
                                    }
                                })
                            }
                        } else {
                            let d = doc.DocumentUrl ;
                            // window.open(d, '_blank');
                            utils.downloadSingleDoc(d)
                        }
                    }
                    else {
                        this.$loading({ 'loadingText': 'Downloading...' })
                        let URL
                        if (section == 'section1')
                            URL = `/I9/GeneratePdfForSection1?section1Id=${doc.Id}`
                        else if (section == 'section2')
                            URL = `/I9/GeneratePdfForSection2?section2Id=${doc.Id}`
                        else if (section == 'section3')
                            URL = `/I9/GeneratePdfForSection3?section3Id=${doc.Id}`
                        else if (section == 'complete')
                            URL = `/I9/GeneratePdfForCompleteI9?consultantId=${loggedInUserObj.consultantId}`
                        if(section == 'complete')
                        {
                            if(CompleteI9PdfUrl){
                                this.$loading({}).close()
                                let d = CompleteI9PdfUrl;
                                utils.downloadSingleDoc(d)
                            }
                            else{
                                ajax.post(URL, {}, (res) => {
                                    if (res.data != '') {
                                        this.$loading({}).close()
                                        let d = res.data;
                                        utils.downloadSingleDoc(d)
                                    }
                                })
                            }
                        }
                        else if(section=='section1')
                        {
                            if(section1PdfUrl){
                                this.$loading({}).close()
                                let d = section1PdfUrl;
                                utils.downloadSingleDoc(d)
                            }
                            else{
                                ajax.post(URL, {}, (res) => {
                                    if (res.data && res.data.GeneratedURL) {
                                        this.$loading({}).close()
                                        let d = res.data.GeneratedURL;
                                        utils.downloadSingleDoc(d)
                                    }
                                })
                            }
                        }
                        /*else if(section=='section2' && !this.IsNullOrEmpty(section2PdfUrl))
                        {
                            this.$loading({}).close()
                            let d = section2PdfUrl + "&download=true";
                            window.open(d, '_blank')
                        }else if(section=='section3' && !this.IsNullOrEmpty(section3PdfUrl))
                        {
                            this.$loading({}).close()
                            let d = section3PdfUrl + "&download=true";
                            window.open(d, '_blank')
                        }*/
                    }
                }
            },

            printDocument(doc, section) {
                if (section == 'everify') {
                    let url
                    doc.DocumentList.forEach((d) => {
                        if (d.DocType == 'DHSEmploymentAuthorization') {
                            url = d.DocumentUrl.replace(/^http:\/\//i, 'https://');
                        }
                    })
                    this.createIframe(url)
                }
                else {
                    if (doc.UploadingExistingI9 == true) {
                        if (section != 'everify') {
                            if(section =='complete'){
                                this.$loading({ 'loadingText': 'Loading...' })
                                URL = `/I9/GeneratePdfForCompleteI9?consultantId=${loggedInUserObj.consultantId}`
                                ajax.post(URL, {}, (res) => {
                                    if (res.data != '') {
                                        this.$loading({}).close()
                                        let url = res.data.replace(/^http:\/\//i, 'https://');
                                        this.createIframe(url)
                                    }
                                })
                            } else {
                                this.createIframe(doc.DocumentUrl.replace(/^http:\/\//i, 'https://'))
                            }

                        }
                    }
                    else {
                        this.$loading({ 'loadingText': 'Loading...' })
                        let URL
                        if (section == 'section1')
                            URL = `/I9/GeneratePdfForSection1?section1Id=${doc.Id}`
                       /* else if (section == 'section2')
                            URL = `/I9/GeneratePdfForSection2?section2Id=${doc.Id}`
                        else if (section == 'complete')
                            URL = `/I9/GeneratePdfForCompleteI9?consultantId=${loggedInUserObj.consultantId}`
                        else if (section == 'section3')
                            URL = `/I9/GeneratePdfForSection3?section3Id=${doc.Id}`*/

                        ajax.post(URL, {}, (res) => {
                            if (res.data && res.data.GeneratedURL) {
                                this.$loading({}).close()
                                let url = res.data && res.data.GeneratedURL.replace(/^http:\/\//i, 'https://');
                                this.createIframe(url)
                            }
                        })
                    }
                }
            },

        }
    }
</script>

<style lang="scss" scoped>

    @import "~styles/framework/vue-utils";

    @import "~styles/framework/bootstrap/progress-bars";

    $default-border-color : #c2c2c2; $default-background-color: #fdfdfd; $success-border-color : #a4f3b5; $success-background-color: #f4fef7; .document-list {
        border-top: 1px dashed #ccc;
        padding: 25px 10px 27px 0;
    }

    .document-list__header {
        position: relative;
        z-index: 1;
        table{
            thead{
            td{
                  width:33.33%;
                  .document-list__statusHeading{
                    font-weight:500;
                    color:#333;
                    padding-top:0px;
                    font-size: 13px;
                    display:block;
                }
              }
            td.document-list__existingI9 {
               padding-left:62px !important;
            }
            }
            tbody{
              td{
                  padding:0px 0 0px 4px;
                  .document-list__statusResult{
                      padding:0px;
                      display:block;
                      color: #F5A623;
                      font-weight:600;
                      padding-left:62px;
                      font-size:10.5px;
                      letter-spacing:0.5px;
                  }
              }
                 .document-list__uploadExisting{
                        .document-list__statusResult{
                            padding-left: 62px;
                        }
                    }
            }
        }
    }
    .document-list__title {
        padding-right: 10px;
    }
    .text_Namefol {
        padding-top: 2px;
        display: inline-block;
    }
    .document-list__uploadedDocs {
        padding: 3px 10px;
        border: 1px solid #5597e3;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: #e6eff9;
        margin: 5px 5px 5px 0px;
        .document-popover{
            background:#f1f1f1;
            p{
                margin:0px;
                color:#333;
                font-weight:600;
             }
             img{
                 cursor:pointer;
             }
        }
    }
    .document-list__heading {
        padding: 5px 10px;
        border: 1px solid $default-border-color;
        display: inline-block;
        border-radius: 30px;
        font-weight: bold;
        background: $default-background-color;
        float: left;
    }

    .document-list__status {
        background: $default-border-color;
        color: $default-background-color;
        padding: 0px 5px;
        border-radius: 100%;
    }

    .document-list__controls {
        float: right;
    }
    .document-list__resendLink {
        color: #4a90e2;
        font-size: 11px;
        font-weight: 600;
        display: block;
        font-style: italic;
        letter-spacing: 0.5px;
        text-decoration: underline;
        padding-top: 6px;
        text-align:right;
    }
    .document-list.document-list--success {
        .document-list__heading{
            border: 1px solid #1DC942;
            background: $success-background-color;
        }

        .document-list__status {
            background: $success-border-color;
            color: #1DC942;
        }
        .document-list__statusResult {
            color: #1DC942;
        }
    }
    .document-list.document-list--failure {
         .document-list__heading{
            border: 1px solid #d92e42;
            background: #ffdadf;
         }
        .document-list__statusResult{
            color:#d92e42;
        }
    }

    .document-list.document-list--pending {
        .document-list__heading{
            border: 1px solid #F5A623;
            background: #FFEED2;
         }
        .document-list__statusResult {
            color: #F5A623;
        }
    }
    .document-list__body {
        position: relative;
        /*top: -18px;*/
        .document-list__uploadedSection{
             padding:5px 0px 0px;
                .document-list__status{
                    font-size: 11px;
                    color: #5597e3;
                    background: #bcd8f8;
                    padding: 1px 6px;
                    margin-left: 5px;
            }
        }
    }

    .i9-document-list-alerts{
        padding: 2px 0px;
    }

    .progress {
        overflow: hidden;
        height: 5px;
        margin-bottom: 0;
        background-color: #f5f5f5;
        border-radius: 10px;
        -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    }

    .upload_div, .upload_file_div {
        padding: 35px;
        background: #FAFEFF;
        border: 2px dashed #ccc;
        border-radius: 8px;
        display: table;
        width: 100%;
        cursor: pointer;
        text-align: center;
        &.dragover

    {
        background: #fff;
    }

    }

    .upload_file_div {
        padding: 15px;
        cursor: default;
    }

    .upload-inner {
        display: table-cell;
        vertical-align: middle;
        padding: 15px;
        width: 15%;
    }

    .width-70 {
        width: 70%;
    }

    .margin-top-25 {
        margin-top: 25px;
    }

    .upload_img {
        padding: 15px 0 20px 0;
    }

    .upload_text {
        padding: 0 0 20px 0;
    }

    .icon {
        width: 50px;
    }

    .icon1 {
        width: 35px;
    }

    .info {
        margin: 0;
        font-size: 13px;
        line-height: 18px;
        color: #999;
        display: inline-block;
    }

    .file_name_span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 600px;
        display: inline-block;
    }


    /* Error */
    .error-holder {
        margin: 10px 0;
    }

    .error-msg {
        color: $ob-error-red;
    }


    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }


    /* Signers list */
    .signature-holder {
        .document-signer

    {
        font-size: 16px;
        font-weight: 600;
        color: #337AB5;
    }

    .signauture-success {
        font-size: 9px;
        color: #FFFFFF;
        background: #3CB55B !important;
    }

    .signauture-pending {
        font-size: 9px;
        color: #FFFFFF;
        background: #008BE7 !important;
    }

    .document-signature-details {
        font-size: 14px;
        color: #2A2A2A;
    }
    }
</style>


<style lang="scss">

    /* animation duration and fill mode */
    .animation {
        animation-duration: 1s;
        animation-fill-mode: both;
        display: inline-block;
    }

    /* bounceOutLeft animation declaration & iteration counting */
    .bounceOutLeft {
        animation-name: bounceOutLeft
    }

    /* bounceOutLeft animation keyframes */
    @keyframes bounceOutLeft {
        18% {
            transform: translate3d(27px, 0, 0)
        }

        33% {
            transform: translate3d(-12px, 0, 0)
        }

        48% {
            transform: translate3d(8px, 0, 0)
        }

        100% {
            transform: translate3d(-300%, 0, 0)
        }
    }

    @keyframes bounceInUp {
        0% {
            opacity: 0;
            -webkit-transform: translateY(2000px);
            -ms-transform: translateY(2000px);
            transform: translateY(2000px);
        }

        60% {
            opacity: 1;
            -webkit-transform: translateY(-30px);
            -ms-transform: translateY(-30px);
            transform: translateY(-30px);
        }

        80% {
            -webkit-transform: translateY(10px);
            -ms-transform: translateY(10px);
            transform: translateY(10px);
        }

        100% {
            -webkit-transform: translateY(0);
            -ms-transform: translateY(0);
            transform: translateY(0);
        }
    }

    .bounceOuttop {
        animation-name: bounceInUp
    }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/ESSComponents/I9DocumentList/I9DocumentList.vue